import { ClientTrackingView } from "./ClientTrackingView";
import GeneralInquiry from "./general-inquiry/GeneralInquiry";
import { ClientsTrackingPermissions } from "../../../Permissions";

export const ClientTrackingTabsData = [
  {
    label: "Client Tracking",
    component: ClientTrackingView,
    permissionsList: Object.values(ClientsTrackingPermissions),
    permissionsId: ClientsTrackingPermissions.ViewClientTracking.permissionsId,
  },
  {
    label: "General Inquiry",
    component: GeneralInquiry,
    permissionsList: Object.values(ClientsTrackingPermissions),
    permissionsId: ClientsTrackingPermissions.ViewGeneralInquiry.permissionsId,
  },
];
